module.exports = __webpack_public_path__ + "static/media/volume.9f0fc957.svg";